module.exports = __webpack_public_path__ + "images/rich_heading/hobby_fashion/game_soft/icon_886251f1f41ce3669d18071c97112849.png";